import React from "react";
import LegalPage from "./LegalPage";

export default function TermsOfService() {
  return (
    <LegalPage title="Terms of Service">
      <p><strong>Last updated:</strong> September 7, 2026</p>

      <p>
        These Terms of Service govern access to and use of Wellora AI and its
        customer relationship management, communication, appointment,
        automation and AI-assisted features.
      </p>

      <h3>Acceptable use</h3>
      <p>
        Users must use Wellora AI lawfully and only for legitimate business and
        customer-service purposes. Users are responsible for ensuring that they
        have appropriate rights, notices and permissions for information entered
        into the platform.
      </p>

      <h3>Connected services</h3>
      <p>
        Wellora AI may connect with third-party services such as WhatsApp
        Business Platform, messaging providers, advertising platforms and AI
        providers. Use of those services may also be subject to the respective
        provider's terms and policies.
      </p>

      <h3>Appointments and AI responses</h3>
      <p>
        Automated responses and scheduling tools are provided to assist
        operations. Businesses remain responsible for reviewing customer
        communications, service availability and appointment accuracy.
      </p>

      <h3>Availability</h3>
      <p>
        We aim to provide reliable service, but uninterrupted availability is
        not guaranteed. Features may be updated, modified or temporarily
        unavailable for maintenance, security or technical reasons.
      </p>

      <h3>Limitation of responsibility</h3>
      <p>
        Wellora AI is a software platform and does not itself provide medical,
        clinical, diagnostic or treatment services.
      </p>

      <h3>Changes to these terms</h3>
      <p>
        These terms may be updated from time to time. Continued use of the
        platform after an update constitutes acceptance of the revised terms.
      </p>
    </LegalPage>
  );
}
